import {
  addLoadingEffect,
  addLoadingForNormalLink,
  ajaxCartNum,
  barbaMarkup,
  cartExpandTrigger,
  enableOuibounceForNormal,
  getTicketEid,
} from '../utils/func.js'

import seatWidget from '../utils/seat-widget.js'

import checkImage from '../components/check-image.js'
import { updateSeatsIframe } from '../components/update-seats-iframe.js'
import { addBtnLoading } from '../components/loading.js'

import initCheckoutTimer from '../components/init-checkout-timer.js'
import { getCookie, setCookie } from '../utils/cookie.js'
import { saveGeolocation } from '../components/getGeolocation.js'
import {
	hideLoadingModal,
	showLoadingModal,
} from '../transitions/show-loading-modal.js'
import getUrlParameter from '../utils/get-url-parameter.js'
import detectMobileWidth from '../utils/detectMobileWidth.js'
import CustomTooltip from '../utils/custom-tooltip'


let fromGiftCardCheckout
// const seatsInReviewCart = []

window.seatsInCartObj = {}
let hideTimeCircle


function preparePromobox() {
  return $('#promo-box')
    .find('.voucher-coupon-entered-result')
    .clone()
    .appendTo('#promo-box-mobile-placeholder')
}

function showHideContent() {
  // const commingFromSeatingChart = getCookie('choiceSeat') === 'fromSeatingChart'
  const commingFromBestAvailable = getCookie('choiceSeat') === 'fromBestAvailable'
  const commingFromSC = getCookie('choiceSeat') === 'fromSC'
	const bvLink = $('#update-link-from-best-available')
	const seatingChartLink = $('#add-more-seats-link-from-seating-chart')
	const scLink = $('#add-more-seats-link-from-sc')
  if (commingFromBestAvailable) {
    bvLink.show()
    seatingChartLink.hide()
    scLink.hide()
  } else if (commingFromSC) {
		bvLink.hide()
    seatingChartLink.hide()
    scLink.show()
  } else {
    bvLink.hide()
    seatingChartLink.show()
    scLink.hide()
  }
}

function updateCheckoutHeader() {
  $('.mobile-header-timer').addClass('flex')
}

function saveSelectSeatsToCookie() {
  window.bake_cookie('seatsInCartObj', window.seatsInCartObj, 1)
}

function initCountDown() {
  fromGiftCardCheckout = Number(getCookie('giftCardCheckout')) === 1
  hideTimeCircle = Boolean(Number($('#ticket-exchange-tip').attr('data-ticket-exchange')) === 1
    || fromGiftCardCheckout)
  if (hideTimeCircle === true) {
    ($('#mobile-header-timer-seating-chart') as any)
      .TimeCircles()
      .destroy()
    $('.mobile-header-timer').remove()
  } else {
    const countDownSeconds = $('#review-cart-countdown-seconds').attr(
      'data-countdown',
    )
    const {alertMessage} = window.myvars
    initCheckoutTimer(
      countDownSeconds,
      alertMessage,
      false,
    )
  }
}

function paymentShowOptpion():void {
  const trigger = document.querySelector('.otherPaymentOpt__triger')
  const buttonsGroup = document.querySelector('.review-cart-btns')
  let isHidden = true
  if(trigger && buttonsGroup) {
    trigger.addEventListener('click', ()=>{
      buttonsGroup.classList.toggle('expand')
      isHidden = !isHidden
      if(isHidden) {
        trigger.textContent = window.myvars.showOtherPaymentOptions
      } else {
        trigger.textContent = window.myvars.hideOtherPaymentOptions
      }
    })
  }
}

function paymentDetect() {
  const buttonsGroup:HTMLElement|null = document.querySelector('.review-cart-btns')
  const trigger = document.querySelector('.otherPaymentOpt__triger')
	const agreement = document.querySelector('#googleapplepay-terms') as HTMLDivElement
	let agreementHeight = 0
	if(agreement) {
		agreementHeight = agreement.getBoundingClientRect().height
	}
  if(trigger && buttonsGroup && detectMobileWidth()) {
    // const style = getComputedStyle(buttonsGroup)
    const {height} = buttonsGroup.getBoundingClientRect()
    if(height<120 + agreementHeight) {
      trigger.classList.add('hidden')
    } else {
      buttonsGroup.style.height=`${agreementHeight + 112}px`
      paymentShowOptpion()
    }
  }

	// if(trigger && buttonsGroup && detectMobileWidth() && agreementHeight > 0) {
  //   buttonsGroup.style.height=`${agreementHeight + 112}px`
  //   paymentShowOptpion()
  // }
}

function pushSeatsId() {
  const $seatsInReviewCart = $('#review-cart-items-tickets').data('json')
  for (let i = 0; i < $seatsInReviewCart.length; i++) {
    // seatsInReviewCart.push($seatsInReviewCart[i].id)
    if (i === 0) {
      $('#hidden-auditorium').val($seatsInReviewCart[i].venueName)
      $('#hidden-event-schedule').val($seatsInReviewCart[i].timeStartDisplay)
    }
    //
  }
}



function imageLoad(img: { src: string; complete: any; onload: (e: any) => void; onerror: (err: any) => void }, src: any) {
  return new Promise<void>((resolve, reject) => {
    img.src = src
    if (img.complete) {
      resolve()
    } else {
      img.onload = (e: any) => {
        resolve(e)
      }

      img.onerror = (err: any) => {
        reject(err)
      }
    }
  })
}

function openImageOnSuccess(this: any, newImg: any) {
  const imageWrapList = document.querySelectorAll(newImg)
  const domLists = imageWrapList.length
  for (let i = 0; i < domLists; i++) {
    const img = imageWrapList[i]

    imageLoad(img, this.src).then(() => {
      img.classList.remove('lazy-loading')
    })
  }
}

function openImageOnFailure() {
  $(
    '.seats-found-img-wrapper, .trigger-inner-label, .seat-location-label',
  ).hide()
}

export function updateSeatsImage(isReturn = false) {
  let imgSrc = ''
  const width = window.chartVars.chartWidth
  const height = window.chartVars.chartHeight
  const chartRatio = height / width

  if (!isReturn) {
    const $selSeats = $('.order-details-item').map(function() {
      return $(this).attr('data-seat-eid')
    })

    const selSeatsArr = $.makeArray($selSeats)

    imgSrc = seatWidget(
      window.myvars.scheduleEid,
      selSeatsArr.join(','),
      800,
      chartRatio,
      false,
    )
  }

  const img = '.seats-found-img'
  checkImage(imgSrc, openImageOnSuccess, img, openImageOnFailure)

  // console.info(imgSrc)
}

function idealAlert() {

  const isIE = window.detectIE()
  const {userAgent} = navigator
  const ideal = document.getElementById('stripe-ideal')

  if (typeof isIE === 'number' && isIE <= 11 && ideal) {
    alert('Please use the latest Chrome, Edge, Firefox, or Safari. iDeal no longer supports Internet Explorer.')
  } else {
    const hrefLink = ideal?.getAttribute('data-href')
    return addLoadingEffect().then(() => new Promise<void>((resolve, _reject) => {
        setTimeout(() => (hrefLink && (window.location.href = hrefLink)), 600)
        return resolve()
      }))
  }
}


function getCurrentStatus() {
		if (getUrlParameter('from') === 'sc') {
			return 'sc'
		}
    const currentStatus = document.body.getAttribute('data-barba-name')
    return currentStatus
}

// window.Select = Select
function getBackLink() {
	const { scheduleEid } = window.myvars
	let backUrl = `/event/view/view/schedule/${scheduleEid}`

	if (getCookie('giftCardCheckout') === '1') {
		backUrl = `${backUrl}/choice/gift`
	} else if (getCookie('choiceSeat') === 'fromBestAvailable') {
		backUrl = `${backUrl}/choice/best-available`
  } else if (getCookie('choiceSeat') === 'fromBundle') {
		backUrl = `${backUrl}/choice/bundle`
	// } else if (getCookie('choiceSeat') === 'fromSC') {
	// 	backUrl = `${backUrl}sc/1`
	} else {
    backUrl = `${backUrl}`
  }

	return backUrl
}

async function goBackTarget() {
	await showLoadingModal()
	const currentPage = getCurrentStatus()

	let backLink
	if (currentPage === 'review-cart') {
		window.location.href = getBackLink()
	} else if (currentPage === 'giftCart') {
		// window.onpopstate()
    history.back()
	} else if (currentPage === 'fastPayment') {
		// window.onpopstate()
    history.back()
	} else if (currentPage === 'sc') {
		backLink = getBackLink()
		const level
			= getCookie('currentLevel') !== '' ? getCookie('currentLevel') : 1
		window.location.href = `${backLink}sc/1/level/${level}`
	}

	hideLoadingModal()
}


function reviewCartOnEnter() {
  barbaMarkup('review-cart')
    // showHideContent()
    // showSeatingChartHeader()
  initCountDown()

  getTicketEid()
  saveSelectSeatsToCookie()
  updateCheckoutHeader()

	window.orderSummaryExpanded = false;
}

function reviewCartOnEnterCompleted() {
  // prepareMobileSubmitBtn()
  preparePromobox()
  showHideContent()
  cartExpandTrigger()
    // cartLoadJsonOrderSummary()
  ajaxCartNum()
  addLoadingForNormalLink()
  addBtnLoading()
  paymentDetect()
  window.CustomTooltip =CustomTooltip;
}


export const ReviewCart = {
  namespace: 'reviewCart',
  // beforeEnter() {
  //   // notReayToBuy()
  // },
  afterEnter() {
    pushSeatsId()
    reviewCartOnEnter()
    reviewCartOnEnterCompleted()
    enableOuibounceForNormal()
    setCookie('currentPage', 'Cart', 1, '')
    saveGeolocation()
  },
}

// window.removeCartNum = removeCartNum
// window.sumTicketLength = sumTicketLength
window.updateSeatsImage = updateSeatsImage
window.updateSeatsIframe = updateSeatsIframe
window.idealAlert = idealAlert
window.goBackTarget = goBackTarget
